import React from 'react';
import { Card, Typography, Tag } from 'antd';
import { Link } from 'react-router-dom';
import './ArchiveItem.css';

const { Title, Text, Paragraph } = Typography;

const ArchiveItem = ({ post }) => {
  const { id, title, excerpt, date, tags, author } = post;

  return (
    <Card 
      hoverable 
      className="archive-item"
    >
      <div className="archive-content">
        <Title 
          level={4} 
          className="archive-title"
        >
          <Link to={`/post/${id}`}>{title}</Link>
        </Title>
        
        <Paragraph 
          ellipsis={{ rows: 2, expandable: false }}
          className="archive-excerpt"
        >
          {excerpt}
        </Paragraph>
        
        <div className="archive-meta">
          <div className="archive-tags">
            {tags && tags.map((tag, index) => (
              <Tag key={index} color="blue">{tag}</Tag>
            ))}
          </div>
          <div className="archive-info">
            <Text type="secondary">{author} • {date}</Text>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ArchiveItem;